import { UpdateAccountInvitesRequestBody } from "@syla/shared/types/requests/UpdateAccountInvitesRequest";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function updateAccountInvites(
  accountId: string,
  props: UpdateAccountInvitesRequestBody,
): Promise<void> {
  try {
    const { data } = await axios.patch(
      `/accounts/${accountId}/access/invite`,
      props,
    );
    return data;
  } catch (error) {
    throwSylaApiError(error);
  }
}
